import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ArrowLeft, Users, ClipboardList, Settings } from 'lucide-react';
import { useAdminNavigation } from '../../../hooks/useAdminNavigation';

// Empty array as navigation items have been removed
const navItems: any[] = [];

export default function SettingsLayout() {
  const { goBack } = useAdminNavigation();

  return (
    <div className="min-h-full">
      {/* Main content */}
      <div className="w-full">
        <div className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <button
              onClick={goBack}
              className="text-gray-500 hover:text-gray-700"
            >
              <ArrowLeft className="h-6 w-6" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Users</h1>
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
